import { useMutation, useQueryClient, UseMutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { deleteTenantGroupOverrides } from 'Services';
import { RQ_TENANT_GROUPS, RQ_TENANT_GROUP_OVERRIDES, RQ_TENANT_GROUP_OVERRIDES_INHERITED } from 'Utils';
import useDeleteTenantGroupOverrideErrorHandler from './useDeleteTenantGroupOverrideErrorHandler';

const deleteOverride = (repoId: number, tenantGroupId: string) => (ruleIds: string[]) => {
    return deleteTenantGroupOverrides(repoId, tenantGroupId, {
        ruleIds
    });
};

type MutationOptions = UseMutationOptions<AxiosResponse<any>, unknown, string[], unknown>;

type Arguments = {
    tenantGroupId: string;
    mutationOptions: MutationOptions;
    ruleId?: string;
    tenantGroupName?: string;
};

const useDeleteTenantGroupRule = ({
    ruleId,
    tenantGroupId,
    mutationOptions: { onSuccess, onError },
    tenantGroupName
}: Arguments) => {
    const { templateRepositoryId } = useTemplateStore.getState().template;
    const queryClient = useQueryClient();
    const errorHandler = useDeleteTenantGroupOverrideErrorHandler({
        mutationOptions: {
            onError
        },
        ruleId,
        queryInvalidateFunction: () => {
            queryClient.invalidateQueries([RQ_TENANT_GROUP_OVERRIDES]);
            queryClient.invalidateQueries([RQ_TENANT_GROUP_OVERRIDES_INHERITED]);
            queryClient.invalidateQueries([RQ_TENANT_GROUPS]);
        },
        tenantGroupId,
        tenantGroupName
    });

    return useMutation(deleteOverride(templateRepositoryId!, tenantGroupId), {
        onSuccess: (data, variables, context) => {
            onSuccess?.(data, variables, context);
        },
        onError: errorHandler
    });
};

export default useDeleteTenantGroupRule;
